module.exports = __webpack_public_path__ + "img/nl.f163721e.svg";